import { render, staticRenderFns } from "./OrdenDetalleComponent.vue?vue&type=template&id=729ce6d5"
import script from "./OrdenDetalleComponent.vue?vue&type=script&lang=js"
export * from "./OrdenDetalleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports